export const SET_CONFIG = '@config/set-config';

